import {Component} from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
   selector: 'app-confirm-removesign-dialog',
   templateUrl: './confirm-removesign-dialog.component.html',
   styleUrls: ['./confirm-removesign-dialog.component.css']
})
export class ConfirmRemovesignDialogComponent {

   messageWarning: string;

   constructor(private dialogRef: MatDialogRef<ConfirmRemovesignDialogComponent>) {
   }

   ok() {
      this.dialogRef.close(true);
   }

}
